<template>
	<div>
		<div class="fs4 fw7 lh125 mt6 mb2">现持有的飞行执照</div>
		<case-form :schema="schemaType" />

		<case-form :schema="schema" class="mt6" />

		<div class="fs4 fw7 lh125 mt6 mb2">
			以飞机师或机组人员身分飞行的时间（小时）
		</div>
		<case-form :schema="schemaHours" />

		<div class="fs4 fw7 lh125 mt6 mb2">您参与飞行活动的目的</div>
		<case-form :schema="schemaPurpose" />

		<div class="fs4 fw7 lh125 mt6 mb2">飞行活动的类型</div>
		<case-form :schema="schemaActivities" />

		<div class="xs-12 fs4 fw7 mb2 mt6">一般飞行方式（往返地点）</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">飞行方式</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaPatterns(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<div class="fs4 fw7 lh125 mt6 mb2">Type of aircraft</div>
		<case-form :schema="schemaTypeOfAircraft" />
		<case-form :schema="schemaOthers" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "../../../../CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schemaType() {
			return [
				{
					label: "学员",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasStudentAviationLicenseCN`,
					props: {
						suggest: {
							typeIncludes: `hasStudentAviationLicenseCN`
						},
						createOptions: {
							type: `hasStudentAviationLicenseCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "康乐",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasRecreationalAviationLicenseCN`,
					props: {
						suggest: {
							typeIncludes: `hasRecreationalAviationLicenseCN`
						},
						createOptions: {
							type: `hasRecreationalAviationLicenseCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "私人",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasPrivateAviationLicenseCN`,
					props: {
						suggest: {
							typeIncludes: `hasPrivateAviationLicenseCN`
						},
						createOptions: {
							type: `hasPrivateAviationLicenseCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "商业",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasCommercialAviationLicenseCN`,
					props: {
						suggest: {
							typeIncludes: `hasCommercialAviationLicenseCN`
						},
						createOptions: {
							type: `hasCommercialAviationLicenseCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "航空运输",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasAirlineTransportAviationLicenseCN`,
					props: {
						suggest: {
							typeIncludes: `hasAirlineTransportAviationLicenseCN`
						},
						createOptions: {
							type: `hasAirlineTransportAviationLicenseCN`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schema() {
			return [
				{
					label: "您是否持有有效的仪器飞行执照？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasValidAviationInstrumentRatingCN`,
					props: {
						suggest: {
							typeIncludes: `hasValidAviationInstrumentRatingCN`
						},
						createOptions: {
							type: `hasValidAviationInstrumentRatingCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "总飞行操作时间",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0aviationTotalHoursInCommandCN`,
					props: {
						suggest: {
							typeIncludes: `aviationTotalHoursInCommandCN`
						},
						createOptions: {
							type: `aviationTotalHoursInCommandCN`,
							dataType: "number"
						}
					}
				},
				{
					label: "未来是否会改变飞行活动？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0willChangeAviationActivitiesCN`,
					props: {
						suggest: {
							typeIncludes: `willChangeAviationActivitiesCN`
						},
						createOptions: {
							type: `willChangeAviationActivitiesCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "如果是，请提供详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0changeAviationActivitiesDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `changeAviationActivitiesDetailsCN`
						},
						createOptions: {
							type: `changeAviationActivitiesDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaHours() {
			return [
				{
					label: "过去 12 个月",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0flyTimeInLast12MonthsCN`,
					props: {
						suggest: {
							typeIncludes: `flyTimeInLast12MonthsCN`
						},
						createOptions: {
							type: `flyTimeInLast12MonthsCN`,
							dataType: "number"
						}
					}
				},
				{
					label: "过去 12 至 24 个月",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0flyTimeInLast24MonthsCN`,
					props: {
						suggest: {
							typeIncludes: `flyTimeInLast24MonthsCN`
						},
						createOptions: {
							type: `flyTimeInLast24MonthsCN`,
							dataType: "number"
						}
					}
				},
				{
					label: "预计未来 12 个月",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0flyTimeInNext12MonthsCN`,
					props: {
						suggest: {
							typeIncludes: `flyTimeInNext12MonthsCN`
						},
						createOptions: {
							type: `flyTimeInNext12MonthsCN`,
							dataType: "number"
						}
					}
				},
				{
					label: "上次飞行日期",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0dateOfLastFlightCN`,
					props: {
						suggest: {
							typeIncludes: `dateOfLastFlightCN`
						},
						createOptions: {
							type: `dateOfLastFlightCN`,
							dataType: "date"
						}
					}
				},
				{
					label: "由",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0dateOfLastFlightFromCN`,
					props: {
						suggest: {
							typeIncludes: `dateOfLastFlightFromCN`
						},
						createOptions: {
							type: `dateOfLastFlightFromCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "至",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0dateOfLastFlightToCN`,
					props: {
						suggest: {
							typeIncludes: `dateOfLastFlightToCN`
						},
						createOptions: {
							type: `dateOfLastFlightToCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaPurpose() {
			return [
				{
					label: "乐趣",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivitiesForPleasureCN`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivitiesForPleasureCN`
						},
						createOptions: {
							type: `isAviationActivitiesForPleasureCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "工作",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivitiesForBusinessCN`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivitiesForBusinessCN`
						},
						createOptions: {
							type: `isAviationActivitiesForBusinessCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "商业",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivitiesForCommercialCN`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivitiesForCommercialCN`
						},
						createOptions: {
							type: `isAviationActivitiesForCommercialCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "军事",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivitiesForMilitaryCN`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivitiesForMilitaryCN`
						},
						createOptions: {
							type: `isAviationActivitiesForMilitaryCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "其他",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivitiesForOtherCN`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivitiesForOtherCN`
						},
						createOptions: {
							type: `isAviationActivitiesForOtherCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "(详情)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0aviationActivitiesForOtherDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `aviationActivitiesForOtherDetailsCN`
						},
						createOptions: {
							type: `aviationActivitiesForOtherDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaActivities() {
			return [
				{
					label: "包机",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypeCharterCN`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypeCharterCN`
						},
						createOptions: {
							type: `isAviationActivityTypeCharterCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "货物运输",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypeFreightTranspoCN`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypeFreightTranspoCN`
						},
						createOptions: {
							type: `isAviationActivityTypeFreightTranspoCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "指导 ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypeInstructionCN`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypeInstructionCN`
						},
						createOptions: {
							type: `isAviationActivityTypeInstructionCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "测量／绘图 ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypeSurveyCN`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypeSurveyCN`
						},
						createOptions: {
							type: `isAviationActivityTypeSurveyCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "测试",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypeTestCN`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypeTestCN`
						},
						createOptions: {
							type: `isAviationActivityTypeTestCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "观光 ",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypeSightSeeingCN`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypeSightSeeingCN`
						},
						createOptions: {
							type: `isAviationActivityTypeSightSeeingCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "喷洒农药",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypeCropCN`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypeCropCN`
						},
						createOptions: {
							type: `isAviationActivityTypeCropCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "商业摄影",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypePhotographyCN`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypePhotographyCN`
						},
						createOptions: {
							type: `isAviationActivityTypePhotographyCN`,
							dataType: "boolean"
						}
					}
				},
				// {
				// 	label: "Aerobatics",
				// 	component: "entityFact",
				// 	entity: "case.insureds[0]",
				// 	relation: "case.insureds[0].facts",
				// 	bindTo: `case.facts.insured0isAviationActivityTypeAerobatics`,
				// 	props: {
				// 		suggest: {
				// 			typeIncludes: `isAviationActivityTypeAerobatics`
				// 		},
				// 		createOptions: {
				// 			type: `isAviationActivityTypeAerobatics`,
				// 			dataType: "boolean"
				// 		}
				// 	}
				// },
				{
					label: "其他",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isAviationActivityTypeOtherCN`,
					props: {
						suggest: {
							typeIncludes: `isAviationActivityTypeOtherCN`
						},
						createOptions: {
							type: `isAviationActivityTypeOtherCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "(详情)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0aviationActivitiesTypeOtherDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `aviationActivitiesTypeOtherDetailsCN`
						},
						createOptions: {
							type: `aviationActivitiesTypeOtherDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaTypeOfAircraft() {
			return [
				{
					label: "定翼飞机",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isFixedWingAircraftTypeCN`,
					props: {
						suggest: {
							typeIncludes: `isFixedWingAircraftTypeCN`
						},
						createOptions: {
							type: `isFixedWingAircraftTypeCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "直升机",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isHelicopterAircraftTypeCN`,
					props: {
						suggest: {
							typeIncludes: `isHelicopterAircraftTypeCN`
						},
						createOptions: {
							type: `isHelicopterAircraftTypeCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "热气球",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isHotAirBalloonAircraftTypeCN`,
					props: {
						suggest: {
							typeIncludes: `isHotAirBalloonAircraftTypeCN`
						},
						createOptions: {
							type: `isHotAirBalloonAircraftTypeCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "超轻型飞机",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isUltralightAircraftTypeCN`,
					props: {
						suggest: {
							typeIncludes: `isUltralightAircraftTypeCN`
						},
						createOptions: {
							type: `isUltralightAircraftTypeCN`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaOthers() {
			return [
				{
					label: "飞机的厂商及型号",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0makeAndModelOfAircraftCN`,
					props: {
						suggest: {
							typeIncludes: `makeAndModelOfAircraftCN`
						},
						createOptions: {
							type: `makeAndModelOfAircraftCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "引擎数目",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0aircraftNumberOfEnginesCN`,
					props: {
						suggest: {
							typeIncludes: `aircraftNumberOfEnginesCN`
						},
						createOptions: {
							type: `aircraftNumberOfEnginesCN`,
							dataType: "string"
						}
					}
				},
				{
					component: "html",
					props: {
						content: `<div class='fs4 fw7 lh125'>引擎类型：</div>`
					},
					bindTo: ""
				},
				{
					label: "螺旋式",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isPropellerAircraftEngineCN`,
					props: {
						suggest: {
							typeIncludes: `isPropellerAircraftEngineCN`
						},
						createOptions: {
							type: `isPropellerAircraftEngineCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "喷射式",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isJetAircraftEngineCN`,
					props: {
						suggest: {
							typeIncludes: `isJetAircraftEngineCN`
						},
						createOptions: {
							type: `isJetAircraftEngineCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "现驾驶飞机的总飞行时间",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0totalHoursInCurrentAircraftCN`,
					props: {
						suggest: {
							typeIncludes: `totalHoursInCurrentAircraftCN`
						},
						createOptions: {
							type: `totalHoursInCurrentAircraftCN`,
							dataType: "number"
						}
					}
				},
				{
					label: "您是否曾驾驶或计划驾驶实验型／自制飞机？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasFlownExperimentalAircraftCN`,
					props: {
						suggest: {
							typeIncludes: `hasFlownExperimentalAircraftCN`
						},
						createOptions: {
							type: `hasFlownExperimentalAircraftCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "如果是，该飞机是否经核证",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isExperimentalAircraftCertifiedCN`,
					props: {
						suggest: {
							typeIncludes: `isExperimentalAircraftCertifiedCN`
						},
						createOptions: {
							type: `isExperimentalAircraftCertifiedCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "国家或地区／机关所提供的核证文件",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0experimentalAircraftCertCN`,
					props: {
						suggest: {
							typeIncludes: `experimentalAircraftCertCN`
						},
						createOptions: {
							type: `experimentalAircraftCertCN`,
							dataType: "string"
						}
					}
				},
				{
					label:
						" 身为飞机师，您曾否遇到意外、迫降，或因触犯航空规例而被罚款或谴责？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasAccidentAsPilotCN`,
					props: {
						suggest: {
							typeIncludes: `hasAccidentAsPilotCN`
						},
						createOptions: {
							type: `hasAccidentAsPilotCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "如果是，请提供详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0accidentAsPilotDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `accidentAsPilotDetailsCN`
						},
						createOptions: {
							type: `accidentAsPilotDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您持有哪一种健康证明书？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0typeOfMedicalCertCN`,
					props: {
						suggest: {
							typeIncludes: `typeOfMedicalCertCN`
						},
						createOptions: {
							type: `typeOfMedicalCertCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "上次领取日期",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0medicalCertDateOfLastRenewalCN`,
					props: {
						suggest: {
							typeIncludes: `medicalCertDateOfLastRenewalCN`
						},
						createOptions: {
							type: `medicalCertDateOfLastRenewalCN`,
							dataType: "date"
						}
					}
				},
				{
					label: "您的健康证明书是否曾被拒绝？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasMedicalCertBeenDeniedCN`,
					props: {
						suggest: {
							typeIncludes: `hasMedicalCertBeenDeniedCN`
						},
						createOptions: {
							type: `hasMedicalCertBeenDeniedCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "如果是，请提供详情",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0medicalCertBeenDeniedDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `medicalCertBeenDeniedDetailsCN`
						},
						createOptions: {
							type: `medicalCertBeenDeniedDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaPatterns(i) {
			return [
				{
					label: "由",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0aviationPatternFrom${i}CN`,
					props: {
						suggest: {
							typeIncludes: `aviationPatternFrom${i}CN`
						},
						createOptions: {
							type: `aviationPatternFrom${i}CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "至",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0aviationPatternTo${i}CN`,
					props: {
						suggest: {
							typeIncludes: `aviationPatternTo${i}CN`
						},
						createOptions: {
							type: `aviationPatternTo${i}CN`,
							dataType: "boolean"
						}
					}
				}
			]
		}
	}
}
</script>
